class Config {

}
// Config.baseUrl = 'https://service.linkda.com.cn/tc_admin_req'
// Config.baseUrl = 'http://106.15.250.223/tc_admin_req'
// Config.baseUrl = 'https://www.mckintey.top/tc_admin_req'
// Config.baseUrl = 'http://101.132.129.64/tc_admin_req';
// Config.baseUrl = 'http://service1.mckintey.top/tc_admin_req'

// Config.baseUrl = '/tc_admin_req';
// 20220601改动:开发时打开上面的，上线时打开下面的
Config.baseUrl = `${window.location.origin}/tc_admin_req`;

Config.header = 'application/json;charset=utf-8';
Config.ERR_CODE = '0';

export { Config };



// WEBPACK FOOTER //
// ./src/api/base/config.js